import { ReactElement } from 'react';
import { ColSizes, ROW_GUTTER } from 'utils/constants/app/ui';
import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import { Action, Header, Title, Wrapper } from './style';
import { Col } from 'newcomponents/UI/Col';
import { Row } from 'newcomponents/UI/Row';
import { Skeleton } from 'newcomponents/UI/Skeleton';

const MatchCardInlineSkeletonCount = 3;

type TMatchCardInlineSkeletonProps = {
  hideOdds?: boolean;
  selectedGames?: boolean;
  isBoostedOdd?: boolean;
};

export const MatchCardInlineSkeleton = ({
  hideOdds,
  selectedGames,
  isBoostedOdd
}: TMatchCardInlineSkeletonProps): ReactElement => {
  return (
    <div style={{ background: 'var(--v3-black-0)' }}>
      <Header>
        <Title>
          <Skeleton
            title={{ style: { width: 100, margin: 0, height: 10 } }}
            paragraph={false}
            active
          />
        </Title>
        <Action>
          <Skeleton
            title={{ style: { width: 20, margin: 0, height: 10 } }}
            paragraph={false}
            active
          />
        </Action>
      </Header>
      <Wrapper isBoostedOdd={isBoostedOdd}>
        <Skeleton
          avatar={{
            shape: 'circle',
            size: selectedGames ? 'default' : 'small',
            style: { width: 20, height: 20, marginTop: 2 },
            ...(selectedGames && {
              style: { marginTop: isMobile() ? '0px' : '-2px' }
            })
          }}
          title={{
            style: { marginTop: 4, marginBottom: 4 }
          }}
          paragraph={false}
          active
        />
        {hideOdds ? null : (
          <Skeleton
            avatar={{
              shape: 'circle',
              size: selectedGames ? 'default' : 'small',
              style: { width: 20, height: 20, marginTop: 2 },
              ...(selectedGames && { style: { marginTop: '4px' } })
            }}
            title={{
              style: { marginTop: 4, marginBottom: 4 }
            }}
            paragraph={false}
            active
          />
        )}

        {hideOdds ? null : (
          <Row gutterV={ROW_GUTTER._4} gutterH={ROW_GUTTER._4}>
            {createArray(MatchCardInlineSkeletonCount).map(key => (
              <Col xs={ColSizes.SIZE_8} key={key}>
                <Skeleton
                  title={{
                    style: {
                      marginTop: 8,
                      marginBottom: 0,
                      height: 32,
                      width: '100%'
                    }
                  }}
                  paragraph={false}
                  active
                />
              </Col>
            ))}
          </Row>
        )}
      </Wrapper>
    </div>
  );
};
